




























import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import AsiAutocomplete from "../common/AsiAutocomplete";
import {enumTextFromValue, isEmpty} from "@/helpers/functions_asi";
import {CompanyType} from "@/helpers/constants";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import {Icon} from "@/helpers/icons";
import OrderListEntry from "@/models/order/OrderListEntry";
import OrderListFilter from "@/models/order/OrderListFilter";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {AsiAvatar, AsiAutocomplete}
})
export default class OrderAutocompleteInput extends Vue {

	@Prop({type: Object, default: null})
	public company!: CompanySimple | null;

	@Prop({default: null})
	public value!: string | string[] | null;

	@Prop({type: Array, default: () => []})
	public orders!: OrderListEntry[];

	@Prop({type: Object, default: null})
	public orderListFilter!: OrderListFilter | null;

	@Prop({type: Array, default: () => []})
	public rules!: (string | null | number | object | unknown | boolean)[];

	@Prop({type: Boolean, default: false})
	public clearable!: boolean;

	@Prop({type: Boolean, default: false})
	public disabled!: boolean;

	@Prop({type: String, default: null})
	public label!: string | null;

	@Prop({type: Boolean, default: false})
	public multiple!: boolean;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	@Prop({type: Boolean, default: false})
	public simple!: boolean;

	private loadingInternal: boolean = false;
	private ordersInternal: OrderListEntry[] = [];
	private icons = Icon;

	private get finalLabel(): string {
		return !isEmpty(this.label) && this.label !== null ? this.label : this.$t('order.singular').toString();
	}

	private get loadingActual(): boolean {
		return this.loading || this.loadingInternal;
	}

	public mounted(): void {
		if (this.orders.length > 0) {
			this.ordersInternal = this.orders;
			this.orderOptionsChanged();
		} else {
			this.loadOrders();
		}
	}

	@Emit('input')
	public input(event: Event): Event {
		return event;
	}

	@Emit('change')
	public change(event: Event): Event {
		return event;
	}

	@Emit('orderOptionsChanged')
	public orderOptionsChanged(): OrderListEntry[] {
		return this.ordersInternal;
	}

	@Watch('orders', {deep: true})
	private onOrdersChanged(value: OrderListEntry[]): void {
		this.ordersInternal = value;
	}

	@Watch('orderListFilter', {deep: true})
	private onOrderListFilterChanged(): void {
		this.loadOrders();
	}

	private loadOrders(): void {
		this.loadingInternal = true;
		if (this.company === null) {
			this.$orderService.orders(this.orderListFilter, null)
				.then((data) => {
					this.ordersInternal = data.data;
					this.orderOptionsChanged();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.loadingError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loadingInternal = false;
				});
		} else {
			this.$companyService.orders(this.company.id, this.orderListFilter, null)
				.then((data) => {
					this.ordersInternal = data.data;
					this.orderOptionsChanged();
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.loadingError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.loadingInternal = false;
				});
		}
	}

	private itemText(order: OrderListEntry): string {
		let ret = order.name;

		const companyParts: string[] = [];
		if (order.company !== null && order.company !== undefined) {
			if (!isEmpty(order.company.name)) {
				companyParts.push(order.company.name);
			}

			const companyType = this.companyTypeLabel(order.company);
			if (companyType !== null) {
				companyParts.push(companyType);
			}
		}

		if (companyParts.length > 0) {
			ret = ret + " (" + companyParts.join(' - ') + ")";
		}

		return ret;
	}

	private companyTypeLabel(company: CompanySimple): string | null {
		return enumTextFromValue(CompanyType, company.type, true);
	}

	private companyAvatarUrl(company: CompanySimple): string | null {
		return CompanySimple.avatarUrlSmall(company);
	}

}
